//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'>
  <div v-if="serverData.loadingDataStatus.mainCommonData != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="serverData.loadingDataStatus.places != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются данные по площадкам
  </div>
  <div v-else-if="place == null" style="width:100%; float:left">
    <div @click="close()"><i class="fas fa-arrow-circle-left back-button"></i></div>
    <div class="placenotfound-text">Площадка не найдена</div>
  </div>
  <div v-else class="place">

    <div class="place-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(place.val.images[0]) + ')'}" @click="close()">
      <i class="fas fa-arrow-circle-left back-button-over"></i>
      <i v-if="isActiveUserAdmin()" class="fas fa-edit back-button-over-right" @click="goToPlaceEdit(place.val.id)"></i>
    </div>

    <div style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="place-name">{{place.val.name}}</div>
    </div>

    <div style="width:100%; padding:30px 0 0 0; float:left;">
      <div class="place-prop">Адрес:</div>
      <div class="place-prop">{{place.val.city}}, {{place.val.address}}</div>
    </div>

    <div v-if="place.val.description != ''" style="width:100%; padding:20px 0 0px 0; float:left;">
      <div class="place-prop">Описание:</div>
      <div class="place-prop">{{place.val.description}}</div>
    </div>

  </div>

  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import serverData from '@/store/serverData'

// import restResource from '@/technical/restResource'
// import serverErrorHandling from '@/technical/serverErrorHandling'

export default {
  components: { },
  props: ['id'],
  data () {
    return {
      placeId: null,
      place: null,
      serverData: serverData, // to make access from UI template
      loadingSpinner: false
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser'
    ])
  },
  created: function () {
    var thisRef = this
    // загружаем данные, когда представление создано и данные реактивно отслеживаются
    this.getPlaceData()
    // подписываемся на загрузку основных данных - когда эта страница это та на которой стартует приложение и на момент created данные еще не подгрузились
    serverData.eventsBus.$on('mainCommonDataLoaded', this.getPlaceData)
    // на realtime обновления places подписываемся на случай если кто-то обновил именно этого места
    serverData.eventsBus.$on('placesChanged', function (data) {
      // вызов этого обработчика будет и пока грузятся основные данные через mainCommonDataLoader что уже обрабатывается
      // через подписку на $on('mainCommonDataLoaded') и второй обработки places нам не надо
      if (data.initiator === 'realtimeServerDataManager') thisRef.getPlaceData(data)
    })
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова. а если сначала смотрели /event/1, ушли, и снова смотрим но /event/2 то кроме как через watch route больше об этом не узнать
    $route: 'getPlaceData'
    // !!!!!! И ВАЖНО ПОМНИТЬ: этот роутер будет вызываться вообще всегда даже когда ходишь по эвентам. поэтому проверку надо на router.path иrouter.name
  },
  methods: {
    // data - это может быть объект из realtimeServerDataManager {method:'update', record:{id, name...}, initiator: "realtimeServerDataManager"}
    // а может быть объект route из watch route. пример = {name:'place', path:'/place/1', params:{id:1}}
    getPlaceData (data) {
      // console.log('----------------')
      // console.log('getPlaceData')
      // console.log(data)
      if ((data != null) && (data.path != null) && (data.name !== 'place')) return // на случай если это вызов через watch route когда ушли со страницы
      if ((data != null) && (data.record != null) && (data.record.id !== this.placeId)) return // другие типы объектов кроме place не придут. и тут на случай если пришло через realtimeServerDataManager обновление но объект с другим id
      // console.log('getPlaceData processing')
      this.placeId = this.id
      if (typeof this.placeId === 'string') this.placeId = parseInt(this.placeId)
      var anPlace = serverData.placesMap[this.placeId]
      if (anPlace == null) { /* console.log('Place.getPlaceData: common data not loaded. exit'); */ return } // это происходит при перезагрузки страницы, данные еще не пришли с сервера
      this.place = Object.assign({}, anPlace)
      // this.place.val = Object.assign({}, anPlace.val)
      // this.place.val.images = Object.assign({}, anPlace.val.images)
    },
    isActiveUserAdmin () {
      if ((this.activeUser != null) && ((this.activeUser.group === 0) || (this.activeUser.group === 1))) return true // суперпользователь или админ
      return false
    },
    goToPlaceEdit (id) {
      this.$router.push({name: 'place-edit', params: {id: id}})
    },
    close () {
      if (this.$router.app._route.name !== 'place') return // это значит что уже перешли куда-то типа place-edit и это close лишнее с обработки картинки а не иконки назад и history.back делать не надо
      // 2 - это значит пустая страница + текущая с продуктом. или 1 - сразу из внешнего приложения открылась эта страница
      if (history.length <= 2) window.location.href = '/' // !!! проверить
      else history.back() // this.$router.go(-1)
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
}
.back-button {
  width: 100%;
  font-size: 35px;
  color: #777;
  padding: 10px 10px 10px 15px;
  cursor: pointer;
  float: left;
}
.back-button-over {
  width: 50px;
  position: relative;
  top: 5px;
  left: 0px;
  font-size: 35px;
  /* color: #888; */
  color: #fff;
  text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777;
  cursor: pointer;
  float: left;
}
.back-button-over-right {
  width: 50px;
  position: relative;
  top: 5px;
  left: calc(100% - 100px);
  font-size: 35px;
  /* color: #888; */
  color: #fff;
  text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777;
  cursor: pointer;
  float: left;
}
.loading-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.placenotfound-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.place {
  width: 100%;
  margin-left: 0%;
  padding-bottom: 40px;
  text-align: center;
  float:left;
}
.place-image {
  width: 100%;
  height: 100vw;
  background: #333;
  background-size: cover;
  background-position: center;
  border-radius: 20px 20px 0 0;
  border-bottom: solid 1px #e0e0e0;
  cursor: pointer;
  float: left;
}
@media screen and (min-width: 450px) {
  .place {
    width: 450px;
    margin-left: calc((100% - 450px) / 2);
  }
  .place-image {
    width: 450px;
    height: 450px;
    border-radius: 20px;
    border: solid 1px #e0e0e0;
  }
}
.place-name {
  /* top: calc(100% - 105px); */
  /* position: relative;
  top: calc(100% - 120px);
  left: calc(15% - 20px);
  width: calc(70% - 40px);
  padding: 20px 20px 20px 20px;
  opacity: 1.0; */
  width: 100%;
  padding: 7px 25px 0px 25px;
  background: #fff;
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  border-right: solid 0px #000;
  border-radius: 10px 10px 10px 10px;
  float:left;
}
.place-prop {
  width: 100%;
  padding: 7px 25px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  float:left;
}
.text-align-left {
  text-align:left;
}
.text-align-right {
  text-align:right;
}
.button-primary{
  margin: 20px 4.5% 20px 4.5%;
  /*background: #6770a6;*/
  border-radius: 15px;
  background: #6070dd;
  font-size: 16px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Place.vue?5ad4647f